export default "__VITE_ASSET__CqlUjYhL__"